import { useState, useEffect, useRef } from 'react';
import { Container } from 'react-bootstrap';
import './../App.css';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FaDownload } from 'react-icons/fa';
import '../styles/privacyRequests.css'
import axios from 'axios'
import FileSaver from "file-saver";
import XLSX from 'sheetjs-style'
import UnsubForm from '../components/forms/UnsubUserForm.js';
import Button from 'react-bootstrap/Button';
import SearchForUserForm from '../components/forms/SearchForUserForm.js';
import PrivacyRequestsTable from '../components/tables/PrivacyRequestsTable';
import FindUserTable from '../components/tables/FindUserTable';

const exportToCSV = (apiData, fileName) => {
  console.log(apiData);

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(apiData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};


function PrivacyRequests(state) {

  const navigate = useNavigate();
  const isLoggedIn = state.isLoggedIn;
  const [suppressionList, setSuppressionList] = useState();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState("");
  const [userErrors, setUserErrors] = useState("");
  const [deleteErrors, setDeleteErrors] = useState("");

  const [success, setSuccess] = useState("");
  const [limit, setLimit] = useState(20);
  const [userData, setUserData] = useState("");
  const [showUserTable, setShowUserTable] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/')
    }
  }, []);

  const downloadTextFile = () => {
    axios
      .get('https://emaildrop.com/privacy/getSuppressionList', {})
      .then(response => {
        setSuppressionList(response.data)
        exportToCSV(suppressionList, "SuppressionList");
      })
      .catch(error => console.log('api errors:', error));
  }

  const unsubUser = (unsubEmail = "") => {
    setErrors("")
    console.log(unsubEmail)
    let emailToSend
    if (unsubEmail) {
      emailToSend = unsubEmail;
      setEmail(unsubEmail);
    } else {
      emailToSend = formData.email;
      setEmail(formData.email)
    }

    axios.post('https://emaildrop.com/privacy/unsub', { email: emailToSend }, {})
      .then(response => {
        if (!response.data.success && !unsubEmail) {
          // only set errors if called from the unsub form - not the privacy table
          if (email == "") {
            setErrors("There was an unexpected error. Please try again.")
          }
        } else if (!unsubEmail) {
          setSuccess(true);
        }
      }
      )
      .catch(error => console.log('api errors:', error));
  }

  const searchForUser = () => {
    setUserErrors("")
    axios.post('https://emaildrop.com/privacy/search', { email: formData.email }, {})
      .then(response => {
        if (!response.data.success) {
          setUserErrors("There was an unexpected error. Please try again.")
        } else {
          console.log(response)
          // make table appear
          setUserData(response.data.leads)
          setShowUserTable(true)
        }
      }
      )
      .catch(error => console.log('api errors:', error));

  }

  const deleteUser = (id) => {
    setUserErrors("")
    axios.post('https://emaildrop.com/privacy/delete', { email: formData.email, id: id }, {})
      .then(response => {
        if (!response.data.success) {
          setDeleteErrors("There was an unexpected error. Please try again.")
        } else {
          console.log(response)
        }
      }
      )
      .catch(error => console.log('api errors:', error));
  }

  return (
    <Container className="App">
      <div className="homeContent">
        <div className="masterSupression w-100">
          <div onClick={downloadTextFile} className="downloadBlacklist"><FaDownload style={{ 'color': 'black' }} /> &nbsp; Download Master Suppression List</div>
        </div>
        <div className="privacyFormDiv">
          <h3>Unsubscribe an Email Adress</h3>
          <div className="privacyForm">
            <UnsubForm onChange={setFormData} />
            <Button onClick={unsubUser} className="formButton" type="submit">
              Submit
            </Button>
          </div>
          {success && (
            <div className="errors d-flex justify-content-start pt-2">
              <p className="text-success"><i className="bi bi-check"></i> &nbsp; Email Successfully Unsubscribed</p>
            </div>
          )}
          {errors && (
            <div className="errors d-flex justify-content-start pt-2 text-danger">
              {errors}
            </div>
          )}
        </div>
        <div className="privacyFormDiv">
          <h3>Search For User</h3>
          <div className="privacyForm">
            <SearchForUserForm onChange={setFormData} searchForUser={searchForUser} />
            <Button onClick={searchForUser} className="formButton" type="submit">
              Submit
            </Button>
          </div>
          {userErrors && (
            <div className="errors d-flex justify-content-start pt-2 text-danger">
              {errors}
            </div>
          )}
        </div>
        {showUserTable && (
          <div className="privacyRequestDiv">
            <h3>Users</h3>
            <FindUserTable showTable={setShowUserTable} onChange={setFormData} unsubUser={unsubUser} deleteUser={deleteUser} userData={userData} errors={userErrors} />
          </div>
        )}
        <div className="privacyRequestDiv">
          <h3>Privacy Requests</h3>
          <PrivacyRequestsTable onChange={setFormData} deleteUser={deleteUser} limit={limit} unsubUser={unsubUser} errors={errors} />
        </div>
      </div>
    </Container>
  );
}

const mapStateToProps = function (state) {
  return {
    user: state.userReducer.user,
    isLoggedIn: state.userReducer.isLoggedIn
  }
}

export default connect(mapStateToProps)(PrivacyRequests);